import script from "./BlogPostCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostCard.vue?vue&type=style&index=0&id=65b8012e&lang=scss"

const __exports__ = script;

export default __exports__